<template>
    <div :class="[{ '--active': showFilters }, filtersClass]">
        <the-btn
            class="filter-close mt-3 d-md-done"
            icon="Close"
            icon-class="text-white"
            @click.native="hideFilters"
        />
        <div class="filter-container">
            <div
                class="btn-filter-wrapper d-flex d-md-none"
                style="height: 74px"
            >
                <the-btn
                    :text="showFilters ? 'Ukryj filtry' : 'Pokaż filtry'"
                    btn-class="btn-filter d-md-none"
                    icon="Filter"
                    icon-class="text-dark"
                    ref="filter-button"
                    @click.native="showFilters = !showFilters"
                />
            </div>
            <h2
                class="promo-heading filter-heading h4 d-flex pb-4"
                :class="[{ '--selected': countSelectedFilters }]"
            >
                <span>Filtry</span>
                <a-count
                    v-if="countSelectedFilters"
                    class="ml-2 --secondary"
                    :data="countSelectedFilters"
                />
                <filter-label
                    v-if="countSelectedFilters"
                    @click.native="clearable && clearFilters()"
                    class="text-uppercase ml-auto filters-clear-label"
                    text="Wyczyść"
                    :style="{
                        cursor: clearable ? 'pointer' : 'not-allowed'
                    }"
                />
            </h2>
            <transition name="slide">
                <div
                    class="filter collapse flex-column gap-1"
                    :class="{ show: showFilters }"
                    id="filter"
                >
                    <component
                        v-for="(filter, fKey) in computedFilters"
                        v-show="!filter.hidden"
                        :key="fKey"
                        :is="`f-${filter.type}`"
                        :filter="filter"
                        :fKey="fKey"
                        :class="[filter.inactive ? 'filter-inactive' : '']"
                        :module-name="moduleName"
                        :style="{ 'pointer-events': filter.inactive ? 'none' : 'auto' }"
                        :filters="filters"
                        @apply-filters="applyFilters"
                        @set-filter="setFilter(fKey, $event)"
                        @set-filter-by-key="setFilter($event.key, $event.value)"
                    />

                    <div
                        v-if="showUserFilters"
                        class="filter-save"
                        :class="{
                            'filter-inactive': $store.getters.isLotteryUser
                        }"
                    >
                        <p class="h6 filter-save-title">
                            <span>Dodaj swój filtr</span>
                        </p>
                        <div class="d-flex">
                            <div class="flex-grow-1">
                                <!-- <input
                                    type="text"
                                    class="form-control user-filter-input"
                                    placeholder="Wpisz nazwę filtra"
                                    id="save-filters"
                                    :disabled="$store.getters.isLotteryUser"
                                    v-model="filterName"
                                    @input="removeDanger"
                                /> -->
                                <the-input
                                    v-model="filterName"
                                    class="user-filter-input"
                                    name="save-filters"
                                    placeholder="Wpisz nazwę filtra"
                                    :disabled="$store.getters.isLotteryUser"
                                    @input="removeDanger"
                                />
                            </div>
                            <div class="flex-grow-0 ml-2">
                                <the-btn
                                    text="Zapisz"
                                    class="filter-save-btn btn btn-outline-custom"
                                    icon="Save"
                                    @click.native="saveFilters"
                                />
                            </div>
                        </div>
                        <div
                            class="flex-grow-0 mt-2 ml-2 text-danger"
                            v-if="error"
                        >
                            {{ error }}
                        </div>
                    </div>

                    <div
                        class="filter-actions"
                        :class="{ 'filter-inactive': disableFiltersClear }"
                    >
                        <the-btn
                            text="Wyczyść filtry"
                            class="btn-block btn-outline-custom"
                            icon="Clear"
                            @click.native="clearable && clearFilters()"
                        />
                        <the-btn
                            text="Pokaż wyniki"
                            class="btn-block btn-secondary mt-3 d-md-none"
                            @click.native="hideFilters"
                        />
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import FUserFilters from './UserFilters.vue'
import FRadio from './Radio.vue'
import FUiVirtualList from './UiVirtualList.vue'
import FUiCheckboxInput from './UiCheckboxInput.vue'
import FCheckboxesGroup from './CheckboxesGroup.vue'
import FSearchInput from './SearchInput.vue'
import FDates from './Dates.vue'
import FRangeDate from './RangeDate.vue'
import FDropdown from './Dropdown.vue'
import FCheckboxes from './Checkboxes.vue'

export default {
    data() {
        return {
            error: '',
            selectedFilter: '',
            showFilters: false,
            refreshIterator: 0
        }
    },
    props: {
        showUserFilters: {
            type: Boolean,
            default: false
        },
        filters: {
            type: Object,
            required: true
        },
        moduleName: {
            type: String,
            required: true
        },
        subtitle: {
            type: String,
            default: 'Pokaż'
        },
        clearable: {
            type: Boolean,
            default: true
        },
        filtersClass: {
            type: String,
            default: 'filter-wrap'
        }
    },
    components: {
        FUserFilters,
        FRadio,
        FUiVirtualList,
        FUiCheckboxInput,
        FCheckboxesGroup,
        FSearchInput,
        FDates,
        FRangeDate,
        FDropdown,
        FCheckboxes
    },
    computed: {
        disableFiltersClear() {
            return (
                this.$store.getters.isLotteryUser &&
                this.$route.name !== 'lotteryUsage'
            )
        },
        userFilter() {
            return this.$store.getters.getUserFilter
        },
        userFilters() {
            return this.$store.getters.getUserFiltersForSelect
        },
        filterName: {
            get() {
                return this.$store.getters.getFilterName
            },
            set(value) {
                this.setFilterName(value)
            }
        },
        countSelectedFilters() {
            let count = 0
            Object.values(this.filters).forEach(filter => {
                if (filter.value && !filter.hidden) {
                    if (
                        typeof filter.value === 'object' &&
                        Object.values(filter.value)
                    ) {
                        count = count + filter.value.length
                    } else {
                        count++
                    }
                }
            })
            return count
        },
        computedFilters() {
            const filters = {}
            Object.entries(this.filters).filter(([key, el]) => el.type).forEach(([key, el]) => {
                if (el.groupName) {
                    // Initialize group if it doesn't exist
                    if (!filters[el.groupName]) {
                        filters[el.groupName] = {
                            ...el,
                            filters: {},
                            type: el.type === 'ui-checkbox-input' ? 'checkboxes-group' : el.type
                        }
                    }

                    // Add the filter to the group
                    filters[el.groupName].filters[key] = {
                        ...el,
                        fKey: key
                    }

                    // Update inactive status based on group's filters
                    filters[el.groupName].inactive = Object.values(filters[el.groupName].filters)
                        .every(v => v.inactive === true)
                } else {
                    // If no groupName, assign filter directly
                    filters[key] = el
                }
            })
            return filters
        }
    },
    methods: {
        loadUserFilter(value) {
            this.$store.dispatch('setUserFilters', value)
        },
        async setFilter(filter, value) {
            const { moduleName, $store } = this

            const computedFilter = this.filters[filter]
            const { groupName = null, resetFilter, triggerClearFilter } = computedFilter

            if (triggerClearFilter) {
                $store.dispatch('setFilter', {
                    filter: triggerClearFilter.filterName,
                    value: triggerClearFilter.value,
                    moduleName
                })
            }

            if (resetFilter) {
                $store.dispatch('setFilter', {
                    filter: resetFilter,
                    value: null,
                    moduleName
                })
            }

            await $store.dispatch('setFilter', {
                filter,
                value,
                moduleName,
                groupName: groupName === 'promoCheckboxes' ? 'promoCheckboxes' : undefined
            })

            this.applyFilters(filter, value)
        },
        setFilterName(value) {
            this.$store.dispatch('setFilterName', value)
        },
        removeDanger() {
            this.error = ''
            const input = document.querySelector('#save-filters')
            input.classList.remove('is-invalid')
        },
        saveFilters() {
            this.error = ''
            if (this.filterName === '' || this.filterName === undefined) {
                this.error = 'Wpisz nazwę filtra'
                const input = document.querySelector('#save-filters')
                input.classList.add('is-invalid')
            } else {
                this.$store
                    .dispatch('sendFilters', this.moduleName)
                    .then(() => {
                        this.filterName = ''
                        this.$store.dispatch('addNotification', {
                            type: 'success',
                            content: 'Zapisano filtr'
                        })
                        this.$store.dispatch('loadUserFilters')
                    })
            }
        },
        applyFilters(filter, value) {
            let doFetch = true
            if (!filter) {
                const filtersRefetch = Object.values(this.filters).map(
                    el => el.noRefetch
                )

                // dont fetch if every filter has flag noRefetch === true
                if (filtersRefetch.every(el => el)) doFetch = false
            } else {
                if (
                    this.computedFilters[filter] &&
                    this.computedFilters[filter].noRefetch
                ) {
                    doFetch = false
                }
            }
            /* eslint-disable eqeqeq */
            if (
                this.$router.currentRoute.query.page &&
                this.$router.currentRoute.query.page != 1
            ) {
                this.$router
                    .push({ query: { ...this.$route.query, page: 1 } })
                    .then(() => {
                        if (doFetch) {
                            return this.$emit('applyFilters', {
                                filter: filter,
                                value: value
                            })
                        }
                    })
            } else {
                if (doFetch) {
                    return this.$emit('applyFilters', {
                        filter: filter,
                        value: value
                    })
                }
            }
        },
        async clearFilters() {
            await this.$store.dispatch('clearFilters', this.moduleName)
            await this.applyFilters()

            this.$emit('clearFilters')

            this.selectedFilter = ''
            this.refreshIterator++
        },
        hideFilters() {
            this.showFilters = !this.showFilters
            const scrollTo = document.querySelector('.c-settings-count')
            if (scrollTo) scrollTo.scrollIntoView()
        }
    },
    mounted() {
        function filterButtonFixed() {
            const button = document.querySelector('.btn-filter')
            const filters = document.querySelector('.filter-container')
            if (!filters) return
            const filtersDistanceToTop = filters.getBoundingClientRect().top
            if (filtersDistanceToTop < 50) {
                button.classList.add('--scrolled')
            } else {
                button.classList.remove('--scrolled')
            }
        }
        filterButtonFixed()

        window.addEventListener('scroll', () => {
            filterButtonFixed()
        })

        window.addEventListener('resize', () => {
            if (window.innerWidth > 768) {
                this.showFilters = false
            }
        })
    }
}
</script>

<style lang="scss">
.filter {
    &-title {
        min-height: 28px;
        line-height: 28px;
    }

    .form-group {
        margin-bottom: 0;
    }

    .user-filter-input {
        height: 49px;
        font-size: 14px !important;
    }
}
</style>
